/* Dynamis homepage (port of site/unboxing/app.js): unboxing progress fallback, step state, rail + keyboard jumps,
   "Skip the animation", the recolour fallback and the paid-buyer count-up.
   Changes for Dawn: the sticky nav is Dawn's header (.section-header); the prototype's email form is gone
   (Dawn's footer has its own); everything re-binds when the theme editor re-renders a section. */
(function () {
  'use strict';
  var html = document.documentElement;
  var params = new URLSearchParams(window.location.search);
  var debugP = params.get('p');
  var cssDriven = window.CSS && CSS.supports('animation-timeline: view()');
  if (debugP !== null) { html.classList.add('debug'); cssDriven = false; }

  /* must match the windows in the critical CSS (snippets/dynamis-critical-home.liquid) */
  /* 2026-10-11 (v2): three tools (tech pack, list, basics) + "all three"; must match the windows in the critical CSS */
  var CAPS = [null, [0.19, 0.30], [0.36, 0.52], [0.59, 0.83], [0.87, 9]];
  var HOLD = [0, 0.25, 0.44, 0.68, 0.965];

  /* ---------- motion mode ----------
     The head script sets the classes at load: motion-ok = motion allowed; motion = the sticky stage (also needs a
     screen taller than 500px in landscape). Rotating the phone or changing the setting flips them live. */
  var mqCalm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqShort = window.matchMedia('(orientation: landscape) and (max-height: 500px)');
  var isMotion = function () { return html.classList.contains('motion'); };
  var onMode = function (fn) {
    [mqCalm, mqShort].forEach(function (m) {
      if (m.addEventListener) m.addEventListener('change', fn); else if (m.addListener) m.addListener(fn);
    });
  };

  /* the bottom edge of Dawn's header while it is pinned (0 when it has scrolled away or isn't sticky) */
  var navBottom = function () {
    var n = document.querySelector('.section-header');
    if (!n || !document.querySelector('sticky-header')) return 0;
    var b = n.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  };

  var S = { stage: null, sticky: null, railBtns: [], lastStep: -1, lastExt: null };
  var ticking = false;

  var progress = function () {
    if (debugP !== null) return parseFloat(debugP) || 0;
    var r = S.stage.getBoundingClientRect();
    var total = S.stage.offsetHeight - window.innerHeight;
    if (total <= 0) return 0;
    return Math.min(1, Math.max(0, -r.top / total));
  };
  var stepFor = function (p) {
    for (var i = CAPS.length - 1; i >= 1; i--) { if (p >= CAPS[i][0] - 0.03) return i; }
    return 0;
  };
  var update = function () {
    ticking = false;
    if (!S.stage || !S.sticky || !S.stage.isConnected) return;
    if (!isMotion()) {
      /* static layout: no scroll-driven state (an inline --p would override the static open-box pose) */
      S.sticky.style.removeProperty('--p');
      if (S.lastStep !== -1) { S.lastStep = -1; S.sticky.setAttribute('data-step', '0'); S.railBtns.forEach(function (b) { b.removeAttribute('aria-current'); }); }
      return;
    }
    var p = progress();
    if (!cssDriven) S.sticky.style.setProperty('--p', p.toFixed(4));
    var s = stepFor(p);
    if (s !== S.lastStep) {
      S.lastStep = s;
      S.sticky.setAttribute('data-step', String(s));
      S.railBtns.forEach(function (b) {
        if (Number(b.getAttribute('data-go')) === s) b.setAttribute('aria-current', 'step');
        else b.removeAttribute('aria-current');
      });
    }
  };
  var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
  var stageTop = function () { return S.stage.getBoundingClientRect().top + window.scrollY; };
  var scrollToStep = function (i, smooth) {
    var total = S.stage.offsetHeight - window.innerHeight;
    window.scrollTo({ top: Math.round(stageTop() + HOLD[i] * total), behavior: smooth ? 'smooth' : 'auto' });
  };

  /* phones: the end pose ("All three. One box.") grows every slot up to just under that caption (critical CSS at
     "THE END POSE ON PHONES"). This measures the free height once per layout (bind, resize, fonts, mode change),
     never per scroll frame. offsetTop/Height ignore the caption's fade-in transform. */
  var fanFit = function () {
    if (!S.sticky || !S.sticky.isConnected) return;
    var capAll = S.sticky.querySelector('.cap--all');
    var rowLayer = S.sticky.querySelector('.layer');
    var ext = '';
    if (isMotion() && capAll && rowLayer && window.matchMedia('(max-width: 900px)').matches) {
      var free = rowLayer.offsetTop - (capAll.offsetTop + capAll.offsetHeight) - 16;
      ext = Math.max(0, Math.round(free)) + 'px';
    }
    if (ext === S.lastExt) return;
    S.lastExt = ext;
    if (ext) S.sticky.style.setProperty('--fan-ext', ext); else S.sticky.style.removeProperty('--fan-ext');
  };
  var onLayout = function () { fanFit(); onScroll(); };

  /* window-level listeners: bound once, always act on the current stage */
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onLayout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fanFit);
  onMode(function () {
    var calm = mqCalm.matches;
    html.classList.toggle('motion-ok', !calm);
    html.classList.toggle('motion', !calm && !mqShort.matches);
    onLayout();
  });

  var bindStage = function (root) {
    var stage = root.querySelector('.unbox');
    var sticky = root.querySelector('.unbox__sticky');
    if (!stage || !sticky || stage.hasAttribute('data-dyn-bound')) return;
    stage.setAttribute('data-dyn-bound', '');
    S.stage = stage; S.sticky = sticky; S.lastStep = -1; S.lastExt = null;
    S.railBtns = Array.prototype.slice.call(root.querySelectorAll('.rail [data-go]'));
    fanFit();
    update();

    S.railBtns.forEach(function (b) {
      b.addEventListener('click', function () { if (isMotion()) scrollToStep(Number(b.getAttribute('data-go')), true); });
    });

    /* "What's inside" links play the box open to the first tool (static layout: a plain jump to the tools) */
    root.querySelectorAll('a[href="#inside"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!isMotion()) return;
        e.preventDefault();
        scrollToStep(1, true);
        var h = document.getElementById('cap-tp');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      });
    });

    /* keyboard: tabbing into a caption scrolls the box to that tool */
    root.querySelectorAll('.tool .cap').forEach(function (cap, idx) {
      cap.addEventListener('focusin', function () {
        var i = idx + 1;
        if (isMotion() && S.lastStep !== i) scrollToStep(i, false);
      });
    });

    /* "Skip the animation": jump straight past the stage to whatever its href names (#singles since 2026-10-11: the
       "Or grab just one" row follows the stage now). The target has scroll-margin-top = the header height. Jump,
       then re-check on the next two frames (the jump changes the scroll-driven state and the sticky header). */
    var skip = root.querySelector('.skip-anim');
    if (skip) {
      skip.addEventListener('click', function (e) {
        var target = document.getElementById((skip.getAttribute('href') || '').slice(1)) || document.getElementById('best');
        if (!target) return;
        e.preventDefault();
        var land = function (left) {
          var off = target.getBoundingClientRect().top - navBottom();
          if (Math.abs(off) > 0.5) window.scrollTo({ top: Math.max(0, Math.round(window.scrollY + off)), behavior: 'instant' });
          if (left > 0) window.requestAnimationFrame(function () { land(left - 1); });
        };
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        target.focus({ preventScroll: true });
        window.requestAnimationFrame(function () { land(2); });
      });
    }

    var copy = root.querySelector('.hero-copy');
    if (copy) copy.addEventListener('focusin', function () { if (isMotion() && S.lastStep !== 0) scrollToStep(0, false); });

    /* recolour fallback for browsers without :has() */
    if (!(window.CSS && CSS.supports('selector(:has(*))'))) {
      var dyn = stage.closest('.dyn') || document.body;
      root.querySelectorAll('input[name="garment"]').forEach(function (r) {
        r.addEventListener('change', function () {
          var chip = r.nextElementSibling;
          var c = chip ? getComputedStyle(chip).backgroundColor : '';
          if (c) dyn.style.setProperty('--garment', c);
        });
      });
    }
  };

  /* ---------- colourway radios: the arrow-key path (polishE-kbd, 2026-10-11) ----------
     Phones (<=480px) hide washed black + chocolate (label.sw--x). WebKit's native radio arrows neither skip a hidden radio
     at the end of the group nor wrap, so on phones Right from Sand got stuck on the hidden Chocolate (and desktop Safari
     stopped at either end). Here the hidden two are disabled while they are hidden (out of the arrow path in every engine,
     never the checked one), a checked colourway that becomes hidden falls back to Sand, and the arrow keys step through
     exactly the enabled chips, wrapping, the same in every engine. Without JS the native behaviour stays. */
  var mqPhoneChips = window.matchMedia('(max-width: 480px)');
  var syncChips = function () {
    var radios = [].slice.call(document.querySelectorAll('input[name="garment"]'));
    if (!radios.length) return;
    radios.forEach(function (r) { r.disabled = mqPhoneChips.matches && !!r.closest('.sw--x'); });
    if (radios.some(function (r) { return r.checked && !r.disabled; })) return;
    var fb = radios.filter(function (r) { return r.value === 'sand' && !r.disabled; })[0] || radios.filter(function (r) { return !r.disabled; })[0];
    if (fb) { fb.checked = true; fb.dispatchEvent(new Event('change', { bubbles: true })); }
  };
  var CHIP_KEYS = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
  document.addEventListener('keydown', function (e) {
    var r = e.target, d = CHIP_KEYS[e.key];
    if (!d || e.altKey || e.ctrlKey || e.metaKey || !r || r.name !== 'garment' || r.type !== 'radio') return;
    var on = [].slice.call(document.querySelectorAll('input[name="garment"]')).filter(function (x) { return !x.disabled; });
    var i = on.indexOf(r);
    if (i < 0) return;
    var n = on[(i + d + on.length) % on.length];
    e.preventDefault();
    n.checked = true; n.focus(); n.dispatchEvent(new Event('change', { bubbles: true }));
  });
  if (mqPhoneChips.addEventListener) mqPhoneChips.addEventListener('change', syncChips); else if (mqPhoneChips.addListener) mqPhoneChips.addListener(syncChips);

  /* ---------- paid-buyer count ----------
     The server renders the real number (sections/dynamis-best). With JS + motion allowed, the inline script next to
     the number already swapped in the START value (data-count) before it could be painted; this counts it up to the
     real number as soon as any of it scrolls into view, so it only ever goes up. Reduced motion = the final number. */
  var bindCount = function (root) {
    root.querySelectorAll('.paid-count[data-paid-buyers]').forEach(function (el) {
      if (el.hasAttribute('data-dyn-bound')) return;
      el.setAttribute('data-dyn-bound', '');
      var n = parseInt(el.getAttribute('data-paid-buyers'), 10);
      if (!(n > 0)) return;
      var fmt = function (v) { return Math.round(v).toLocaleString('en-US'); };
      var finalText = fmt(n);
      var from = parseInt(el.getAttribute('data-count'), 10);
      var canCount = !mqCalm.matches && 'IntersectionObserver' in window && window.requestAnimationFrame;
      if (!canCount || !(from > 0) || from >= n) { el.textContent = finalText; el.removeAttribute('data-count'); return; }
      var DUR = 1200;
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        var t0 = null;
        var tick = function (t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / DUR);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = k < 1 ? fmt(from + (n - from) * eased) : finalText;
          if (k < 1) window.requestAnimationFrame(tick);
          else el.removeAttribute('data-count');
        };
        window.requestAnimationFrame(tick);
      }, { threshold: 0 });
      io.observe(el);
    });
  };

  var init = function (root) { bindStage(root); bindCount(root); syncChips(); };
  init(document);
  /* theme editor: a section re-render replaces its DOM; bind the new one */
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); onScroll(); });
})();
